import { useTranslation } from '@crehana/i18n';
import locales from "../i18n";
import { NOTIFICATIONS_COMPONENTS_I18N_KEY } from "../i18n/constants";
export function useNotificationsComponentTranslations() {
  var ctx = useTranslation(NOTIFICATIONS_COMPONENTS_I18N_KEY);
  return ctx;
}
export var useAddResourceBundleToNotificationsComponentTranslations = function useAddResourceBundleToNotificationsComponentTranslations() {
  var ctx = useTranslation(NOTIFICATIONS_COMPONENTS_I18N_KEY);
  ctx.addResourceBundle(locales);
};